export const zIndex = {
  messagesBar: 1,
  intercom: 2,
  cookieBanner: 3,
};
